import script from "./FilialiSubPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FilialiSubPage.vue?vue&type=script&setup=true&lang=js"

import "./FilialiSubPage.vue?vue&type=style&index=0&id=4dcb260a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dcb260a"]])

export default __exports__